import React, { useEffect, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { format } from 'date-fns';

function LatestNewsBanner() {
    const [latestNews, setLatestNews] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchLatestNews = async () => {
            try {
                const res = await axios.get(
                    `${process.env.REACT_APP_BACKEND_API_URL}/api/news?sort[0]=order:asc&sort[1]=Date:desc&pagination[limit]=1&populate=*`
                );
                
                if (res.data && res.data.data && res.data.data.length > 0) {
                    const item = res.data.data[0];
                    const attrs = item.attributes || item;
                    const unique = attrs.unique ?? item.unique;
                    const isExternal = attrs.Content?.indexOf('redirect_to_url') === 0;
                    const link = unique ? `/news/${unique}` : `/news/${item.id}`;
                    const href = isExternal ? attrs.Content.replace('redirect_to_url=', '') : link;

                    setLatestNews({
                        id: item.id,
                        title: attrs.Title,
                        date: attrs.Date,
                        href,
                        isExternal,
                    });
                }
            } catch (error) {
                console.error('Error fetching latest news for banner:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchLatestNews();
    }, []);

    const formatDate = (dateStr) => {
        if (!dateStr) return '';
        try {
            return format(new Date(dateStr), 'MMMM d, yyyy');
        } catch {
            return dateStr;
        }
    };

    if (loading) {
        return (
            <section className="latest-news-banner py-4">
                <Container>
                    <div className="text-white opacity-75">Loading latest updates...</div>
                </Container>
            </section>
        );
    }

    if (!latestNews) {
        return null; // Return nothing if no news or fetch fails
    }

    return (
        <section className="latest-news-banner py-4 py-md-5" id="latest-news-updates">
            <Container>
                <Row className="align-items-center">
                    <Col md={8} lg={9} className="mb-4 mb-md-0">
                        <div className="latest-news-banner__eyebrow">
                            <span className="latest-news-banner__rule" aria-hidden="true" />
                            <span className="latest-news-banner__label">
                                Latest News & Corporate Updates
                            </span>
                        </div>
                        <div className="latest-news-banner__date mb-2">
                            {latestNews.date}
                        </div>
                        <h3 className="latest-news-banner__title mb-0">
                            {latestNews.isExternal ? (
                                <a
                                    href={latestNews.href}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="latest-news-banner__title-link"
                                >
                                    {latestNews.title}
                                </a>
                            ) : (
                                <Link to={latestNews.href} className="latest-news-banner__title-link">
                                    {latestNews.title}
                                </Link>
                            )}
                        </h3>
                    </Col>
                    <Col md={4} lg={3} className="d-flex justify-content-md-end justify-content-start">
                        <Link to="/news" className="latest-news-banner__cta">
                            View Latest News <span className="latest-news-banner__cta-arrow">➔</span>
                        </Link>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}

export default LatestNewsBanner;
